import { AppAlert } from '@components/antd';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useAppBanner } from './hooks/use-app-banner';

export const MfaSetupReminderBanner = () => {
  const { mfaBanner } = useAppBanner();
  const { t } = useTranslation();
  return (
    <AppAlert
      showIcon
      type="warning"
      message={
        <p>
          {t('to_help_keep_your_account_secure_set_up_two_factor_authentication_with_an_extra_verification_step')}
          <Button
            className="cursor-pointer mx-2.5! text-xs! h-[25.5px]! px-5! rounded-sm!"
            onClick={mfaBanner.handleLater}
            loading={mfaBanner.loading}
          >
            {t('later')}
          </Button>
          <Button
            className="cursor-pointer text-xs! h-[25.5px]! px-[5px]! rounded-sm! bg-text-950! text-surface!"
            onClick={mfaBanner.handleSetupMFa}
          >
            {t('setup_2fa')}
          </Button>
        </p>
      }
    />
  );
};
